import React from 'react';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemButton,
    Paper,
    Divider,
} from '@mui/material';
import {
    Settings,
    Help,
    Info,
    AccountCircle,
    Notifications,
    Language,
    Security,
    Feedback,
    ExitToApp,
} from '@mui/icons-material';
import MobileContainer from '../global/components/MobileContainer';
import { MAIN_COLOR_RED } from '../assets/styles';
import { useNavigate } from 'react-router-dom';

const MorePage: React.FC = () => {
    const navigate = useNavigate();

    const menuItems = [
        {
            id: 'profile',
            title: 'Profile',
            icon: <AccountCircle />,
            description: 'Manage your account',
        },
        {
            id: 'notifications',
            title: 'Notifications',
            icon: <Notifications />,
            description: 'Configure alerts',
        },
        {
            id: 'settings',
            title: 'Settings',
            icon: <Settings />,
            description: 'App preferences',
        },
        {
            id: 'language',
            title: 'Language',
            icon: <Language />,
            description: 'Change language',
        },
        {
            id: 'security',
            title: 'Security',
            icon: <Security />,
            description: 'Privacy & security',
        },
        {
            id: 'help',
            title: 'Help & Support',
            icon: <Help />,
            description: 'Get help',
        },
        {
            id: 'feedback',
            title: 'Send Feedback',
            icon: <Feedback />,
            description: 'Share your thoughts',
        },
        {
            id: 'about',
            title: 'About',
            icon: <Info />,
            description: 'App information',
        },
        {
            id: 'exit',
            title: 'Exit',
            icon: <ExitToApp />,
            description: 'Switch persona / restart flow',
        },
    ];

    const handleItemClick = (itemId: string) => {
        if (itemId === 'exit') {
            // Optionally clear persona-related state so the user can pick again.
            try {
                localStorage.removeItem('selectedPersona');
                localStorage.removeItem('userId');
                localStorage.removeItem('activeShoppingListId');
            } catch {
                // ignore storage errors
            }
            navigate('/');
            return;
        }
        // Other menu items can be handled here as needed.
        console.log(`Clicked: ${itemId}`);
    };

    return (
        <MobileContainer>
            <Box sx={{ mb: 3 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    More
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Settings and additional options
                </Typography>
            </Box>

            <Paper sx={{ overflow: 'hidden' }}>
                <List>
                    {menuItems.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <ListItem disablePadding>
                                <ListItemButton
                                    onClick={() => handleItemClick(item.id)}
                                    sx={{
                                        py: 2,
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                        },
                                    }}
                                >
                                    <ListItemIcon sx={{ color: MAIN_COLOR_RED }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={item.title}
                                        secondary={item.description}
                                        primaryTypographyProps={{
                                            fontWeight: 500,
                                        }}
                                        secondaryTypographyProps={{
                                            fontSize: '0.875rem',
                                        }}
                                    />
                                </ListItemButton>
                            </ListItem>
                            {index < menuItems.length - 1 && <Divider />}
                        </React.Fragment>
                    ))}
                </List>
            </Paper>

            <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary">
                    App Version 1.0.0
                </Typography>
            </Box>
        </MobileContainer>
    );
};

export default MorePage;
